import { useRSStore } from '../store/useRSStore'
import { readFwListAPI, readFwFilesAPI, addFwAPI, updateFwAPI, deleteFWAPI, paginationFwAPI } from '../api/FwAPI'

import type { fwfile, fwfilter, updatefw } from '../types/types'


export function useFw() {
  const RSStore = useRSStore()
  const onReadFwList = async (fwfilter: fwfilter) => {
    try {
      const list = await readFwListAPI(fwfilter)
      RSStore.fwList = list
    } catch (e) {
      console.error("fw 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onReadFwFiles = async () => {
    try {
      const list = await readFwFilesAPI()
      //[{ name: 'test1.bin', size: 1024, md5: true },
      //{ name: 'test2.bin', size: 2048, md5: false },]
      RSStore.fwFileList = list.map((item, index) => ({
        ...item,
        id: index
      }))
      console.log("fw 파일 데이터 로드 완료:", RSStore.fwFileList)
    } catch (e) {
      console.error("fw 파일 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddFw = async (fw: fwfile[]) => {
    try {
      const result = await addFwAPI(fw)
      console.log("fw 추가 완료 id:", result)
    } catch (e) {
      console.error("fw 추가 중 에러 발생:", e)
    }
  }

  const onUpdateFw = async (updatefw: updatefw) => {
    try {
      const result = await updateFwAPI(updatefw)
      if (result) {
        console.log("fw 업데이트 완료 :", updatefw)
      } else {
        console.error("fw 업데이트 실패 입력값 확인 필요", updatefw)
      }
    } catch (e) {
      console.error("fw 업데이트 중 에러 발생:", e)
    }
  }

  const onDeleteFw = async (fwId: number) => {
    try {
      const result = await deleteFWAPI(fwId)
      if (result) {
        console.log("fw 삭제 완료 id:", fwId)
      } else {
        console.error("fw 삭제 실패 입력값 확인 필요", fwId)
      }
    } catch (e) {
      console.error("fw 삭제 중 에러 발생:", e)
    }
  }

  const onPaginationFw = async (fwfilter: fwfilter) => {
    try {
      const result = await paginationFwAPI(fwfilter) ?? 0
      return result
    } catch (e) {
      console.error("fw 페이지 수 가져오는 중 에러 발생:", e)
    }
  }

  return {
    onReadFwList,
    onReadFwFiles,
    onAddFw,
    onUpdateFw,
    onDeleteFw,
    onPaginationFw,
  }
}